var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_965_7971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23C0 23.552 0.448 24 1 24H23C23.552 24 24 23.552 24 23V18C24 17.448 23.552 17 23 17H1C0.448 17 0 17.448 0 18V23Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 0H1C0.448 0 0 0.448 0 1V6C0 6.552 0.448 7 1 7H23C23.552 7 24 6.552 24 6V1C24 0.448 23.552 0 23 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 15.5H23C23.552 15.5 24 15.052 24 14.5V9.5C24 8.948 23.552 8.5 23 8.5H1C0.448 8.5 0 8.948 0 9.5V14.5C0 15.052 0.448 15.5 1 15.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_965_7971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridSelected);
export default __webpack_public_path__ + "static/media/grid-selected.21aef7546ffa7d625ab9a781d1ae5104.svg";
export { ForwardRef as ReactComponent };